<template>
	<div>
		<Table :columns="columns1" :data="ChargeCards" style="width: 100%;"></Table>
	</div>
</template>

<script>
	
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import webapi from '../../../../webapi'
	export default {
		props: {
			row: Object
		},
		data() {
			const _this = this;
			return {
				methodList: [{
						name: 'delete',
						Status:  this.$t('Common.Delete') 
					},
					{
						name: 'lost',
						Status: this.$t('Common.Lost')
					},
					{
						name: 'unlost',
						Status: this.$t('Common.UnLost')
					},
					{
						name: 'lock',
						Status:  this.$t('Common.Lock') 
					},
					{
						name: 'unlock',
						Status: this.$t('Common.UnLock') 
					},
					{
						name: 'edit',
						Status:  this.$t('Common.Edit')
				}],
				columns1: [{
						title: this.$t('Number'),
						type: 'index',
						width: 60,
						align: 'center'
					}, {
						title: this.$t('Common.CreateTime'),
						key: 'CreateTime',
						width: 160,
					}, {
						title: this.$t('Model.Member.CardNo') ,
						key: 'CardNo',
						width: 150,
					}, {
						title: this.$t('Model.Member.MemberId') ,
						key: 'GroupId',
						width: 250,
					},
					
					{
						title: this.$t('Model.Member.Status') ,
						key: 'State',
						width: 100,
						render: (h, params) => {
							return h('div', params.row.StateDesc)
						}
					},
					{
						title: this.$t('Model.Member.CarNo') ,
						key: 'CarNo',
						width: 100
					},
					{
						title: this.$t('Individual.RestrictedStations'),
						key: 'StationList',
						width: 200,
						render: (h, params) => {
							let station = ''

							for (let var1 of params.row.StationArray) {
								let stationName = _this.StationList.filter(function(item, index, arr) {

									return item.StationId == var1
								})[0].StationName
								station += stationName + ','
							}
							if (params.row.StationArray.length == 0) {
								station =  this.$t('Common.All')
							}
							return h('div', station)
						}
					},
				
					{
						title: this.$t('Model.Member.Remarks') ,
						key: 'Remark',
						width: 100,
					},
				
					{
						title: this.$t('Common.Actions'),
						key: 'action',
						width: 200,
						align: 'center',
						render: (h, params) => {
							return h('div', [
								
								this.methodList.filter(item => this.hasWidgets(item.name)).length > 0 ? h('Dropdown', {
										on: {
											//To avoid incorrect operations, confirm and cancel should function oppositely.
											'on-click': (name) => {
												if (name == this.$t('Common.Edit')) {
													this.otherMethod(name, params.row.GroupId, params
														.row.CardNo);
												} else {
													this.$Modal.confirm({
														title: name,
														okText: this.$t('Common.Cancel'),
														cancelText: this.$t('Common.Confirm'),
														onCancel: () => {
															this.otherMethod(name, params
																.row.GroupId, params
																.row.CardNo);
														}
													});
												}
												// this.show("deleteStation", params.row.Id)
											}
										},
										props: {
											transfer: true,
										}
									},
									[
										h('Button', {
											props: {
												type: 'primary',
												size: 'small',
											},
											style: {
												marginRight: '5px'
											},
										}, this.$t('Individual.ChargingCardActions')),
										h('DropdownMenu', {
											slot: 'list'
										}, [
											this.methodList.filter(item => this.hasWidgets(item.name)).map((
												item) => { 
												return h('DropdownItem', {
														props: {
															name: item.Status
														}
													},
													item.Status
												)
											})
										])
									],
								) : h()
							]);
						}
					}
				],
			
				ChargeCards: this.row.ChargeCards,
			}
		},
		computed: {
		
			...mapState({
				StationList: 'Stations'
			})
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			//Except for delete and modify operations
			otherMethod: function(type, GroupId, CardNo) {
				switch (type) {
					case this.$t('Common.Delete') :
						this.DeleteCard(GroupId, CardNo)
						break;
					case this.$t('Common.Lost'):
						this.LostCard(GroupId, CardNo)
						break;
					case this.$t('Common.UnLost') :
						this.UnLostCard(GroupId, CardNo)
						break;
					case this.$t('Common.Lock') :
						this.LockCard(GroupId, CardNo)
						break;
					case this.$t('Common.UnLock'):
						this.UnLockCard(GroupId, CardNo)
						break;
					case this.$t('Common.Edit'):
						this.$emit("upCard", GroupId, CardNo)
						break;
				}
			},
			
			DeleteCard: function(GroupId, CardNo) {
				const _this = this;
				let parms = {
					GroupId: GroupId,
					CardNo: CardNo
				};
				_this.$axios.post(webapi.base_api_url + "/Member/DeleteChargeCard", parms, {}).then(res => {
				
					console.log(res.data)
					if (res.data.Code == 0) {
						this.$Message.success(this.$t('Common.OperationSuccess'));
						_this.$emit("upData")
					} else {
						this.$Message.error(this.$t('Common.OperationFailed'));
						this.$Message.error(res.data.Msg + "---" + res.data.Data);
					}
				})
			},
			LostCard: function(GroupId, CardNo) {
				const _this = this;
				let parms = {
					GroupId: GroupId,
					CardNo: CardNo
				};
				_this.$axios.post(webapi.base_api_url + "/Member/LostCard", parms, {}).then(res => {
					
					console.log(res.data)
					if (res.data.Code == 0) {
						this.$Message.success(this.$t('Common.OperationSuccess'));
						_this.$emit("upData")
					} else {
						this.$Message.error(this.$t('Common.OperationFailed'));
						this.$Message.error(res.data.Msg + "---" + res.data.Data);
					}
				})
			},
			
			UnLostCard: function(GroupId, CardNo) {
				const _this = this;
				let parms = {
					GroupId: GroupId,
					CardNo: CardNo
				};
				_this.$axios.post(webapi.base_api_url + "/Member/UnLostCard", parms, {}).then(res => {
					
					console.log(res.data)
					if (res.data.Code == 0) {
						this.$Message.success(this.$t('Common.OperationSuccess'));
						_this.$emit("upData")
					} else {
						this.$Message.error(this.$t('Common.OperationFailed'));
						this.$Message.error(res.data.Msg + "---" + res.data.Data);
					}
				})
			},
		
			LockCard: function(GroupId, CardNo) {
				const _this = this;
				let parms = {
					GroupId: GroupId,
					CardNo: CardNo
				};
				_this.$axios.post(webapi.base_api_url + "/Member/LockCard", parms, {}).then(res => {
				
					console.log(res.data)
					if (res.data.Code == 0) {
						this.$Message.success(this.$t('Common.OperationSuccess'));
						_this.$emit("upData")
					} else {
						this.$Message.error(this.$t('Common.OperationFailed'));
						this.$Message.error(res.data.Msg + "---" + res.data.Data);
					}
				})
			},
			
			UnLockCard: function(GroupId, CardNo) {
				const _this = this;
				let parms = {
					GroupId: GroupId,
					CardNo: CardNo
				};
				_this.$axios.post(webapi.base_api_url + "/Member/UnLockCard", parms, {}).then(res => {
					
					console.log(res.data)
					if (res.data.Code == 0) {
						this.$Message.success(this.$t('Common.OperationSuccess'));
						_this.$emit("upData")
					} else {
						this.$Message.error(this.$t('Common.OperationFailed'));
						this.$Message.error(res.data.Msg + "---" + res.data.Data);
					}
				})
			},
		}
	}
</script>

<style>
</style>
